import React, { memo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { SS } from "root/libs/constants/src";
import { localization } from "root/libs/core-libs/src";
import { DhlButton, DhlText } from "@dhl-official/react-library";
import { Sizes } from "@dhl-official/stencil-library";
import LanguageSelector from "../LanguageSelector";
import Textarea from "../../Forms/Textarea";
import {
  StyledSettingsComponent,
  SettingsContainerWrapper,
  SettingsCol,
  StyledText,
} from "./styled";

const Settings = ({
  environment,
  initialPayload,
  locales,
  onNewEvent,
  onUpdateLocale,
  selectedLocale,
  version,
  availableAbTestingOptions,
  availableCanaryVersionsOptions,
}) => {
  const [eventPayload, setEventPayload] = useState(initialPayload);

  useEffect(() => {
    document.querySelector("html").setAttribute("lang", selectedLocale);
  }, [selectedLocale]);

  return (
    <StyledSettingsComponent>
      <DhlText weight={800} isParagraph>
        {version ? `Version: ${version}` : ""}
        <br />
        Environment:
        {` ${environment}`}
      </DhlText>

      <StyledText size={Sizes.SM}>
        {" "}
        This section is used for development purposes only. Hide with:&nbsp;
        <code>
          localStorage.setItem(&#34;environmentSettingsEnabled&#34;, false);
        </code>
      </StyledText>

      <SettingsContainerWrapper>
        <SettingsCol>
          <LanguageSelector
            selectedLocale={selectedLocale}
            locales={locales}
            onChange={({ target }) => {
              const locale = target.value;
              const country = localization.getCountry(locale);
              const language = localization.getLanguage(locale);

              onUpdateLocale({
                country,
                language,
                locale,
              });
            }}
          />
          <br />
          <DhlText weight={800} isParagraph>
            Available A/B Testing variants:
          </DhlText>
          <code>{availableAbTestingOptions}</code>
          <br />
          <br />
          <DhlText weight={800} isParagraph>
            Available Canary Versions:
          </DhlText>
          <code>{availableCanaryVersionsOptions}</code>
        </SettingsCol>

        <SettingsCol>
          <fieldset>
            <legend>Update to trigger personalization events:</legend>
            <Textarea
              copyNamespace={SS}
              height="150px"
              label="Personalization Object"
              name="commentsSettings"
              onChange={({ target }) => setEventPayload(target.value)}
              value={eventPayload}
            />

            <br />

            <DhlButton
              name="button"
              clickEvent={() => {
                onNewEvent(JSON.parse(eventPayload));
              }}
              type="submit"
            >
              Trigger Personalization event
            </DhlButton>
          </fieldset>
        </SettingsCol>
      </SettingsContainerWrapper>
    </StyledSettingsComponent>
  );
};

Settings.propTypes = {
  environment: PropTypes.string.isRequired,
  initialPayload: PropTypes.string.isRequired,
  locales: PropTypes.any.isRequired,
  onNewEvent: PropTypes.func.isRequired,
  onUpdateLocale: PropTypes.func.isRequired,
  selectedLocale: PropTypes.string.isRequired,
  version: PropTypes.string,
  availableAbTestingOptions: PropTypes.string.isRequired,
  availableCanaryVersionsOptions: PropTypes.string.isRequired,
};

Settings.defaultProps = {
  version: "",
};

export default memo(Settings);
